var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-select',_vm._g(_vm._b({attrs:{"options":_vm.options},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var label = ref.label;
var products_count = ref.products_count;
return [_vm._v("\n        "+_vm._s(label)),(_vm.showCount)?_c('span',{staticClass:"text-muted ml-1"},[_vm._v(" ("+_vm._s(products_count)+")")]):_vm._e()]}},{key:"no-options",fn:function(ref){
var search = ref.search;
var searching = ref.searching;
return [(searching)?[_vm._v("\n            Hittade inga resultat på "),_c('em',[_vm._v(_vm._s(search))]),_vm._v(".\n        ")]:_c('em',{staticStyle:{"opacity":"0.5"}},[_vm._v("Sök på kategori")])]}}])},'vue-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }